import { useTranslation } from 'react-i18next';
import ExportAccountingTransferOrderForm from '@/components/forms/export-accounting-transfer-order-form/export-accounting-transfer-order-form';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  ExportAccountingTransferOrderModalApi,
  useExportAccountingTransferOrderModalViewModel,
} from './export-accounting-transfer-order-modal.viewmodel';

export const ExportAccountingTransferOrderModal = ({
  onSuccess,
  onClose,
  onCancel,
}: ExportAccountingTransferOrderModalApi) => {
  const { t } = useTranslation();
  const viewModel = useExportAccountingTransferOrderModalViewModel({
    api: {
      onSuccess,
      onClose,
      onCancel,
    },
  });

  return (
    <Dialog
      open={true}
      onOpenChange={(open) => {
        if (!open) viewModel.api.close();
      }}
    >
      <DialogContent
        className="sm:max-w-2xl"
        showCloseButton={false}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>
            {t('export-accounting-transfer-order-modal.title')}
          </DialogTitle>
          <DialogDescription>
            {t('export-accounting-transfer-order-modal.description')}
          </DialogDescription>
        </DialogHeader>

        <ExportAccountingTransferOrderForm form={viewModel.form} />

        <DialogFooter>
          <Button
            variant="secondary"
            onClick={viewModel.api.cancel}
          >
            {t('btn.cancel')}
          </Button>

          <Button
            onClick={viewModel.api.submit}
            loading={viewModel.data.saving}
          >
            {t('btn.save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
